module.exports = __webpack_public_path__ + "static/media/hex-active.535f958d.svg";